// 认证类型
export const ACTION_AUTHORIZE_TYPE = {
  none: {
    type: 'none',
    text: '无'
  },
  service_http: {
    type: 'service_http',
    text: 'API Key'
  },
  oauth: {
    type: 'oauth',
    text: 'OAuth'
  },
  platform: {
    type: 'platform',
    text: '其他平台'
  }
}

/**
 * 自定义 API Key 授权方式
 */
export const CUSTOM_APIKEY_AUTHORIZE_TYPE = {
  header: {
    type: 'header',
    text: 'Header'
  },
  query: {
    type: 'query',
    text: 'Query'
  }

  //   ,
  //   body: {
  //     type: 'body',
  //     text: 'Body'
  //   }
}

/**
 * 令牌交换方式
 */
export const TOKEN_EXCHANGE_METHOD = {
  header: {
    type: 'header',
    text: '基本授权头'
  },
  post: {
    type: 'post',
    text: 'POST请求'
  },
  query: {
    type: 'query',
    text: 'Query'
  }
}

export const KNOWLEDGE_CONFIG_MODE = {
  auto: 'auto',
  rag: 'rag',
  doc: 'doc'
}
export const KNOWLEDGE_OVER_LIMIT_ACTION = {
  tranc: 0,
  delete: 1
}
export const KNOWLEDGE_WORD_COUNT = {
  fiftyThousand: 50000,
  OneHundredThousand: 100000,
  oneHundredAndFiftyThousand: 150000,
  twoHundredThousand: 200000
}

export const FIlE_EXTENSION_LIST = ['pdf', 'doc', 'docx', 'xlsx', 'txt', 'epub', 'mobi', 'azw3']

export const AUDIO_EXTENSION_LIST = ['wav', 'mp3', 'wma', 'aac', 'ogg', 'amr', 'flac', 'm4a']

export const MAX_UPLOAD_COUNT = 1000
export const MAX_PROCESSING_COUNT = 20
export const FILE_POLLING_TIME = 30 * 1000

/**
 * 创建页面分组名称
 */
export const SECTION_ITEMS = {
  BASIC: 'basic',
  UI: 'ui',
  MODEL: 'model',
  LIB: 'lib',
  ADVANCED: 'advanced',
  DIALOG: 'dialog',
  ABILITY: 'ability'
}

export const LIB_AUTH_TYPE = {
  wechat: 'weixin_knowledge',
  weixin: 'weixin',
  weibo: 'weibo'
}

export const DATE_RANGE_OPTIONS = [
  {
    label: '1个月内的内容',
    value: 1
  },
  {
    label: '半年内的内容',
    value: 6
  },
  {
    label: '1年内的内容',
    value: 12
  },
  {
    label: '全部发布内容',
    value: 0
  }
]
export const DATE_RANGE_OPTIONS_WEIBO = [
  {
    label: '最近发布内容',
    value: 0
  }
]
export const UPDATE_METHODS = [
  {
    label: '每日更新',
    value: 1
  },
  {
    label: '不更新',
    value: 0
  }
]
export const AUTH_FILE_PLACEHOLDER = {
  weixin: 'weixin_placeholder',
  weibo: 'weibo_placehoder'
}
export const DIALOG_MODE = {
  opening_ui: 'opening_ui',
  digital: 'digital_human',
  normal: 'normal'
}
export const COMPONENT_TYPE = {
  singleLine: 'text_box',
  multiLine: 'text_area',
  paragraph: 'text',
  tag: 'tag',
  select: 'selector'
}
export const COMPONENT_MAXLEN = {
  singleLine: 50,
  multiLine: 1024,
  title: 30,
  paragraph: 100,
  tagWords: 6,
  tagCount: 10,
  selectorWords: 20,
  selectorCount: 50,
  allCount: 10
}
